export const config = {
  apiKey: 'AIzaSyCCDTBiJZ9w2tz9h1ogASU_7hL5zI_Imio',
  authDomain: 'weekly-dinner.firebaseapp.com',
  databaseURL: 'https://weekly-dinner.firebaseio.com',
  storageBucket: 'weekly-dinner.appspot.com'
};
